<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[selections$, addressSetup$, invoices$, sessions$]"></ef-loading-container>
<div class="card">
    <div class="mb-3">
        <ef-invoice-setup-filters-container
            (SelectContract)="onSelectContract($event)">
        </ef-invoice-setup-filters-container>
    </div>

    <div class="invoice-container">
        <ef-invoice-setup-presenter [invoiceProperties]="invoiceProperties$ | async"
            [accountClassProperties]="accountClassProperties$ | async"
            [signatureLineProperties]="signatureLineProperties$ | async"
            [invoiceViewOptions]="invoiceViewOptions$ | async" [disclaimerProperties]="disclaimerProperties$ | async"
            [paymentTermsProperties]="paymentTermsProperties$ | async" [selections]="selections$ | async"
            [states]="states$ | async" [addressTypes]="addressTypes$ | async" [addressSetup]="addressSetup$ | async"
            [invoices]="filteredInvoices$ | async" [addresses]="addressSelectItems$ | async"
            [remitAddresses]="remitAddressSelectItems$ | async" [billingAddresses]="billingAddressSelectItems$ | async"
            [invoiceSelections]="selectionSelectItems$ | async" [invoiceContracts]="invoiceContractSelectItems$ | async"
            [chargeNumbers]="chargeNumberSelectItems$ | async" [invoiceTypes]="invoiceTypeSelectItems$ | async"
            [sessions]="filteredSessions$ | async" [invoiceSessions]="invoiceSessionSelectItems$ | async"
            (SaveAddress)="onSaveAddress($event)" (SaveSelection)="onSaveSelection($event)"
            (DeleteSelection)="onDeleteSelection($event)" (SaveAddress)="onSaveAddress($event)"
            (DeleteAddress)="onDeleteAddress($event)" (SaveInvoiceOptions)="onSaveInvoiceOptions($event)"
            (SaveSession)="onSaveSession($event)" (UpdateBulkInvoiceSetups)="onUpdateBulkInvoiceSetups($event)"
            (UpdateBulkVouchers)="onUpdateBulkVouchers($event)"></ef-invoice-setup-presenter>
    </div>
</div>
